import React from "react"
import { Button } from "reactstrap"
import "./ListingTabs.css"

function ListingTabs({ tabs = [], activeTab, onChange, className = "", activeValueKey = "id" }) {
    if (!tabs.length) return null

    return (
        <div className={`bos-listing-tabs ${className}`.trim()}>
            <div className="bos-listing-tabs__rail">
                {tabs.map((tab) => (
                    <Button
                        key={tab.id}
                        type="button"
                        color="primary"
                        value={tab[activeValueKey]}
                        onClick={() => onChange?.(tab[activeValueKey], tab)}
                        className={[
                            "bos-listing-tabs__item",
                            activeTab === tab[activeValueKey] ? "is-active" : "",
                            tab.floatRight ? "is-right-aligned" : "",
                            tab.iconOnly ? "is-icon-only" : "",
                        ].filter(Boolean).join(" ")}
                        title={tab.name}
                        aria-label={tab.name}
                    >
                        {tab.iconClassName && (
                            <span className="bos-listing-tabs__icon">
                                <i className={tab.iconClassName} aria-hidden="true"></i>
                            </span>
                        )}
                        {!tab.iconOnly && <span className="bos-listing-tabs__label">{tab.name}</span>}
                    </Button>
                ))}
            </div>
        </div>
    )
}

export default ListingTabs
